import { defaultMutationFn } from 'api';
import { useMutation } from 'react-query';

export function useSendResetPassword(email: string) {
  return useMutation({
    mutationFn: () => {
      return defaultMutationFn('/authenticate/sendResetPassword', 'POST', {
        email,
      });
    },
  });
}
